
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCollisionAvoidancePortSide as ObiCollisionAvoidancePortSideElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-collision-avoidance-port-side.js';
 
 
 

 
 export const ObiCollisionAvoidancePortSide = createComponent({
   react: React,
   tagName: 'obi-collision-avoidance-port-side',
   elementClass: ObiCollisionAvoidancePortSideElement,
   events: {
     
   }
  });
 
 